import combineReducers from '../../../utilities/combineReducers';
import entities from './entities';
import selected from './selected';

export default combineReducers({
  entities,
  selected,
});



// WEBPACK FOOTER //
// ./src/modules/organizations/reducers/index.js